import { gql } from '@apollo/client'

import { REVIEW_FEEDBACK_FRAGMENT } from '../fragments'

export const NEXT_CLASSIFICATION_CORRECTION = gql`
  query NextClassificationCorrection($upc: String) {
    nextClassificationCorrection(upc: $upc) {
      __typename
      ... on ClassificationCorrection {
        returnedFeedbackCount
        reviewFeedback {
          ...ReviewFeedbackFields
        }
        crop {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          isHumanAdded
          isHumanDeleted
          isFlagged
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
              resolved
            }
          }
          verifiedUpc
          currentUpc
          leasedById
          leasedAt
        }
        candidates {
          id
          upcA
          name
          brandName
          marketingImageUrl
          packaging
        }
        image {
          id
          imageUrl
        }
      }
      ... on NoItemsAvailableError {
        code
        message
      }
      ... on LeaseLockError {
        code
        message
        retryAfterMs
      }
    }
  }
  ${REVIEW_FEEDBACK_FRAGMENT}
`
